export enum ButtonTheme {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  CANCEL = 'cancel',
  SUCCESS = 'success',
  CREATE = 'create',
  WARNING = 'warning',
  ERROR = 'error',
  MAPZOOM = 'map-zoom',
  MAPRESET = 'map-reset',
  MINIMAL = 'minimal',
  NONE = 'none'
}
